import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye, ChevronLeft, ChevronRight } from "lucide-react";
import { useGetNotificationActivityApiCallQuery } from "@/services/api/auth/auth.api";

export const ViewLog = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;

  const {
    data: notificationData,
    isLoading,
    isError,
  } = useGetNotificationActivityApiCallQuery({
    page: currentPage,
    limit,
  });

  console.log(notificationData);

  const totalPages = notificationData?.result?.pages || 1;

  const handlePrev = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const handleNext = () => setCurrentPage((p) => Math.min(p + 1, totalPages));

  return (
    <div className="max-w-7xl mx-auto p-4 space-y-4">
      <h2 className="text-lg font-semibold">Activity Logs</h2>

      <div className="border rounded-md overflow-hidden">
        <Table>
          <TableHeader className="bg-gray-100 dark:bg-gray-800">
            <TableRow>
              <TableHead>Activity</TableHead>
              <TableHead>Type</TableHead>
              {/* <TableHead>Status</TableHead> */}
              <TableHead>Date</TableHead>
              <TableHead>User ID</TableHead>
              {/* <TableHead className="text-right">Actions</TableHead> */}
            </TableRow>
          </TableHeader>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={6} className="text-center h-24">
                  Loading...
                </TableCell>
              </TableRow>
            ) : isError ? (
              <TableRow>
                <TableCell
                  colSpan={6}
                  className="text-center h-24 text-red-500"
                >
                  Failed to load logs
                </TableCell>
              </TableRow>
            ) : notificationData?.result?.docs &&
              notificationData?.result?.docs?.length > 0 ? (
              notificationData.result.docs.map((log, idx) => (
                <TableRow
                  key={log._id}
                  className={
                    idx % 2 === 0
                      ? "bg-white dark:bg-gray-900"
                      : "bg-gray-50 dark:bg-gray-800"
                  }
                >
                  <TableCell className="max-w-xs truncate">
                    {log.activity}
                  </TableCell>
                  <TableCell>{log.type}</TableCell>
                  {/* <TableCell>{log.status}</TableCell> */}
                  <TableCell>
                    {new Date(log.createdAt).toLocaleString()}
                  </TableCell>
                  <TableCell className="truncate">{log.userId}</TableCell>
                  {/* <TableCell className="text-right">
                    <Button size="icon" variant="ghost">
                      <Eye className="h-4 w-4" />
                    </Button>
                  </TableCell> */}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} className="text-center h-24">
                  No logs found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>

      {totalPages > 1 && (
        <div className="flex justify-between items-center pt-4 border-t border-gray-200 dark:border-gray-700 mt-4">
          <div className="flex items-center gap-2">
            <Button
              onClick={handlePrev}
              disabled={currentPage === 1}
              variant="secondary"
              size="sm"
              className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
            >
              <ChevronLeft className="h-4 w-4 mr-1" /> Prev
            </Button>

            <Button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              variant="secondary"
              size="sm"
              className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
            >
              Next <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
          </div>

          <span className="text-sm text-gray-600 dark:text-gray-300">
            Page <span className="font-medium">{currentPage}</span> of{" "}
            <span className="font-medium">{totalPages}</span>
          </span>
        </div>
      )}
    </div>
  );
};
